import React, { Component } from 'react';
import { Input, Radio } from 'antd';
import FileTypeSelect from '../FileTypeSelect';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class MediaSearchAndPicker extends Component {
	render() {
		const { searchTerm, handleSearch, listType, changeListType } = this.props;
		return (
			<>
				<Input.Group
					style={{
						display: 'flex',
						marginBottom: '1em',
					}}
				>
					<FileTypeSelect value={searchTerm} handleChange={handleSearch} />
					<Input.Search
						placeholder="Media Search"
						onSearch={handleSearch}
						enterButton
						onPressEnter={handleSearch}
					/>
					<RadioGroup onChange={changeListType} defaultValue={listType} style={{ display: 'flex' }}>
						<RadioButton value="thumbnail">Thumbnail</RadioButton>
						<RadioButton value="list">List</RadioButton>
					</RadioGroup>
				</Input.Group>
			</>
		);
	}
}
